import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { graphql } from 'react-apollo';
import * as compose from 'lodash.flowright';
import { gql } from 'apollo-boost';
import Tooltip from '@material-ui/core/Tooltip';
import $ from 'jquery';


import {name} from '../../validations/validation';
// styles , icons and images
import { Container, Row, Col, Modal } from 'react-bootstrap';
import { InputLabel, IconButton, Button, InputBase, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import './question.style.css';
import more from './images/more.png';

// this component represents the questions part of the create and edit visume page

class Questions extends Component {
    constructor() {
        super();
        this.state = {
            range: "35",
            questionInputs: [],
            questions: [],
            inputs: [],
            yourQuetions: "",
            show: false,
            toggle: false,
            deleted: false

        }
    }
    componentWillReceiveProps(props) {
        this.setState({ ...this.state, questions: props.data.questions })
        let list = document.getElementById("left-tabs-example");
        let nav_items = list.querySelectorAll(".nav-item a");
        for (let i = 0; i < nav_items.length; i++) {
            nav_items[i].setAttribute("aria-disabled", "true")
            nav_items[i].classList.add("disabled")
        }
    }
    componentDidMount() {

        let add = document.querySelector(".custom-input button");

        // plus icon on click
        add.addEventListener("click", function () {
            this.setState({ ...this.state, errorMessage: '' });
            let allQuestions = document.querySelectorAll('.question-title');
            let flag;
            for (let i = 0; i < allQuestions.length; i++) {
                if (allQuestions[i].textContent === this.state.title) {
                    flag = 0;
                }
            }
            if (name(this.state.title)) {
                let error = name(this.state.title);
                this.setState({ ...this.state, errorMessage: error });
                return false;
            }
            else if (flag === 0) {
                this.setState({ ...this.state, errorMessage: 'This field  is already exist' });
                return false;
            }
            else if (allQuestions.length >= 5) {
                this.setState({ ...this.state, errorMessage: 'The limit of questions for each Visume is 5.' });
                return false;
            }
            else {
                this.setState({ ...this.state, errorMessage: '' });
                // make a list 
                let inputValue = document.querySelector(".custom-input input").value;
                let questionInputs = { title: inputValue}
                this.setState({ ...this.state, questions: [...this.state.questions, questionInputs], title: "", range: "35" });
                return true;
            }
        }.bind(this));

    }

    handleBackBtn = () => {
        let list = document.getElementById("left-tabs-example");
        let nav_items = list.querySelectorAll(".nav-item a");
        nav_items[0].click();

        this.closeAllMenues();
    }
    handleClick = (e) => {
        let elem = e.currentTarget;
        if (elem.querySelector('.custom-list')) {
            elem.querySelector('.custom-list').classList.toggle('d-none')
        }
    }
    closeAllMenues = () => {
        let menues = document.querySelectorAll('.custom-list');

        menues.forEach(menu => menu.classList.add('d-none'))
    }

    // **** handle removeChild issue *** //
    // (Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.) 
    HandleRemoveIssue = () => {
        if (typeof Node === 'function' && Node.prototype) {
            const originalRemoveChild = Node.prototype.removeChild;
            Node.prototype.removeChild = function (child) {
                if (child.parentNode !== this) {
                    if (console) {
                        console.error('Cannot remove a child from a different parent', child, this);
                    }
                    return child;
                }
                return originalRemoveChild.apply(this, arguments);
            }

            const originalInsertBefore = Node.prototype.insertBefore;
            Node.prototype.insertBefore = function (newNode, referenceNode) {
                if (referenceNode && referenceNode.parentNode !== this) {
                    if (console) {
                        console.error('Cannot insert before a reference node from a different parent', referenceNode, this);
                    }
                    return newNode;
                }
                return originalInsertBefore.apply(this, arguments);
            }
        }
    }// end of handle code

    handleDelete = (e) => {
        e.currentTarget.closest('.questionParent').classList.add('v-hidden');
        document.querySelector('.custom-ol .v-hidden').remove();
        this.HandleRemoveIssue();
    }
    handleEdit = (e) => {
        // get index of question you want to edit
        let items = document.querySelectorAll(".custom-ol .questionParent .question-title p"),
            tab = [], index;
        for (var i = 0; i < items.length; i++) {
            tab.push(items[i].innerHTML);
        }
        index = tab.indexOf(e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.question-title').textContent);
        let questionToEdit = e.currentTarget.parentNode.parentNode.parentNode.parentNode.parentNode.querySelector('.question-title').textContent;
        this.setState({ ...this.state, questionToEdit: questionToEdit, questionAfterEdit: questionToEdit, indexOfEdit: index, show: true })

    }
    render() {

        const handleChange = prop => event => {
            this.setState({ ...this.state, [prop]: event.target.value });

        };

        const checkquestion = (listOfQuestions) => {
            if (listOfQuestions.length < 1) {
                this.setState({ ...this.state, errorMessage: 'You must enter at least one question' });
                return false;

            } else {
                this.setState({ ...this.state, errorMessage: '' });
                return true;
            }
        }
        const handleClose = () => this.setState({ ...this.state, errorMessageEdit: '', show: false });
        // this.HandleRemoveIssue();


        // the comment code is for : 
        //  the limit time of each question but it delayed .
        return (
            <div className="pb-3">
                <form onSubmit={e => 
                    {
                    e.preventDefault();
                    // close setting menue
                    this.closeAllMenues();
                    // get biography id 
                    let list = document.getElementById("left-tabs-example");
                    let nav_items = list.querySelectorAll(".nav-item a");
                    let bioId = nav_items[0].getAttribute("data-id");

                    // get list of questions and limits 
                    const listItems = document.querySelectorAll('.question-title');
                    // const listLimit = document.querySelectorAll('.question-limit');

                    let inputs = "", arrayOfQuestions = [];
                    for (let i = 0; i < listItems.length; i++) {
                        //let questionInputs = { title: listItems[i].textContent, maximum_time: listLimit[i].textContent, minimum_time: 0, mandatory: true, ordering: 0 }
                        let questionInputs = { title: listItems[i].textContent }
                        let question = { id: listItems[i].getAttribute('data-id') }
                        inputs = { question: (question.id) ? question : null, questionInputs: questionInputs }
                        arrayOfQuestions.push(inputs);
                    }

                    if (checkquestion(arrayOfQuestions)) {
                        // send mutation varaibles of bio/visume question
                        this.props.createQuestions({
                            variables: {
                                bio_id: { id: bioId },
                                Inputs: arrayOfQuestions
                            }
                        }).then((res) => {
                            if (res.data.questionArray.Status.code === 200) {
                                // go to next form  and make it not disabled !
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                                let list = document.getElementById("left-tabs-example");
                                let nav_items = list.querySelectorAll(".nav-item a");
                                nav_items[2].click();
                                this.setState({...this.state , ConnectionErorr : ''});

                            }
                        }).catch((err) => this.setState({ ...this.state, ConnectionErorr: "There is something wrong happened, please try again later." }));
                    }
                    }}>
                    <Container className="overview shadow border-rounded bg-white">
                        <Row>
                            <Col className=" border-bottom p-5 bg-light" sm={12}>
                                <div className="title">
                                    <h4 className="text-dark">Questions</h4>
                                    <p className="text-grey mb-0">Add your questions that helps the employer to know you more</p>
                                    <p className="text-grey mb-0">(Your response to each question you create is limited to 1 minute. Your final Visume will not exceed 5 minutes in length ).</p>
                                </div>
                            </Col>
                            <Col className="text-dark p-5">
                                <InputLabel htmlFor="title">
                                    Question Title<span className="text-danger"> *</span>
                                </InputLabel>
                                <div className="custom-input mt-1">
                                    <InputBase
                                        placeholder="Write your question title"
                                        onChange={handleChange('title')}
                                        id="title"
                                        name="title"
                                        value={this.state.title}
                                        className="w-90 pl-2"
                                    />
                                    <IconButton color="primary" className="offset-8" aria-label="directions">
                                        <AddIcon />
                                    </IconButton>
                                </div>
                                <Col xs={12} className="p-0 pb-4">
                                    <Typography variant="subtitle1" className="text-danger">{this.state.errorMessage}</Typography>
                                </Col>
                                {/* <div className="pt-3 pb-3">
                                    <Row>
                                        <Col sm={7} xs={12} className="text-left"> <label htmlFor="range">Time limit ( second )*</label></Col>
                                        <Col sm={5} xs={12} className="text-center">
                                            <input type="range" id="range" name="range" min="10" onChange={handleChange('range')} value={this.state.range} max="60" />
                                            <Row className="m-0 ">
                                                <Col><span className="pr-1">10 sec</span></Col>
                                                <Col><span className="pl-3 pt-3">{this.state.range} sec</span></Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div> */}
                                <div><p className="mb-0">Your Questions<span className="border-b-1"></span></p></div>
                                <div className=" text-dark pt-2 pb-2">
                                    <ol className="w-100 pl-0 custom-ol">
                                        {(this.state.questions) ?
                                            this.state.questions.map(input =>
                                                <Row className="bg-lightgrey m-0 pt-2 pb-2 mt-1  questionParent">
                                                    <Col sm={1} xs={1} className="dots mr-3-responsive">
                                                        <button
                                                            type="button"
                                                            className="more-btn"
                                                            onClick={this.handleClick}>
                                                            <ul data-id={(input.id) ? input.id : ''} className="shadow custom-list d-none">
                                                                <li className="list-style-none p-0 text-center edit-option">
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.handleEdit}
                                                                        className="bg-transparent border-0 w-100 pt-1 pb-1 pr-3 pl-3" >
                                                                        Edit
                                                                    </button>
                                                                </li>
                                                                <li className="list-style-none text-center delete-option p-0">
                                                                    <button
                                                                        type="button"
                                                                        onClick={this.handleDelete}
                                                                        className="bg-transparent border-0 pt-1 pb-1 pr-3 pl-3">Delete</button>
                                                                </li>
                                                            </ul>
                                                            <img src={more} alt="more" />
                                                        </button>
                                                    </Col>
                                                    <Col xs={10} className="p-0">
                                                        <li className="w-100">
                                                            <Row className="m-0">
                                                                <Col xs={12} data-id={(input.id) ? input.id : ''} className="p-0 text-left question-title"><p className="mb-0">{input.title}</p></Col>
                                                            </Row>
                                                        </li>
                                                    </Col>
                                                </Row>
                                            ) : ''}
                                        <Modal className="modal-edit row m-0 " show={this.state.show} onHide={handleClose}>
                                            <Col xs={12}>
                                                <Modal.Header closeButton>
                                                    <Modal.Title className="h6">Edit Question</Modal.Title>
                                                </Modal.Header>
                                                <Modal.Body>
                                                    <InputLabel htmlFor="title">
                                                        Question Title<span className="text-danger"> *</span>
                                                    </InputLabel>
                                                    <div className="custom-input  mt-1 pl-2">
                                                        <InputBase
                                                            className="inputToEdit w-100"
                                                            placeholder="Write your question title"
                                                            onChange={handleChange('questionAfterEdit')}
                                                            id="title"
                                                            name="title"
                                                            defaultValue={this.state.questionToEdit}
                                                        />
                                                    </div>
                                                    <Col xs={12} className="p-0 pb-1">
                                                        <Typography variant="subtitle1" className="text-danger">{this.state.errorMessageEdit}</Typography>
                                                    </Col>
                                                    {/* <div className="pt-3 pb-3">
                                                <Row>
                                                    <Col sm={6} xs={12} className="text-left"> <label htmlFor="range">Time limit ( second )*</label></Col>
                                                    <Col sm={6} xs={12} className="text-center">
                                                        <input type="range" id="range" name="range" className="rangeToEdit" min="10" onChange={handleChange('limitAfterEdit')} defaultValue={this.state.limitToEdit} max="60" />
                                                        <Row className="m-0 ">
                                                            <Col><span className="pr-1">10 sec</span></Col>
                                                            <Col><span className="pl-3 pt-3">{this.state.limitAfterEdit} sec</span></Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </div> */}
                                                </Modal.Body>
                                                <Modal.Footer className="custom">
                                                    <Button type="button" size="small" className="btn-orange-gradiant" variant="contained" onClick={() => {
                                                        // validation of question
                                                        let allQuestions = document.querySelectorAll('.question-title');
                                                        let flag = 1;
                                                        for (let i = 0; i < allQuestions.length; i++) {
                                                            if (i !== this.state.indexOfEdit) {
                                                                if (allQuestions[i].textContent === this.state.questionAfterEdit) {
                                                                    flag = 0;
                                                                }
                                                            }
                                                        }
                                                        if (name(this.state.questionAfterEdit)) {
                                                            let error = name(this.state.questionAfterEdit);
                                                            this.setState({ ...this.state, errorMessageEdit: error });
                                                            return false;
                                                        }
                                                        else if (flag === 0) {
                                                            this.setState({ ...this.state, errorMessageEdit: 'This field  is already exist' });
                                                            return false;
                                                        }
                                                        else {
                                                            this.setState({ ...this.state, errorMessageEdit: '' });
                                                            // get the new value of question
                                                            // get list of question in the list
                                                            let newvalue = document.querySelector('.inputToEdit input').value;
                                                            let allQuestions = document.querySelectorAll('.question-title');
                                                            // get the new limit of question
                                                            // get list of range in the list
                                                            // let newLimitValue = document.querySelector('.rangeToEdit').value;
                                                            // let allLimits = document.querySelectorAll('.question-limit');
                                                            // edit the question and limit
                                                            allQuestions[this.state.indexOfEdit].querySelector('p').innerHTML = newvalue;
                                                            //allLimits[this.state.indexOfEdit].innerHTML = newLimitValue;
                                                            handleClose();
                                                        }
                                                    }}>
                                                        Save Changes
                                                </Button>
                                                </Modal.Footer>
                                            </Col>
                                        </Modal>
                                    </ol>
                                </div>
                                <Col xs={12} className="pb-3">
                                    <Typography variant="subtitle1" className="text-danger">{this.state.ConnectionErorr}</Typography>
                                </Col>
                            </Col>
                        </Row>
                    </Container>
                    <div className="w-100">
                        <Col xs="6" className="d-inline-block p-0 pt-4 text-left">
                            <Tooltip title="if you click back, you will lose the question you just entered.">
                                <Button 
                                    type="button" 
                                    onClick={this.handleBackBtn} 
                                    size="large" 
                                    className="btn-white-outline pr-5 pl-5" 
                                    variant="contained" 
                                >Back</Button>
                            </Tooltip>
                        </Col>
                        <Col xs="6" className="d-inline-block p-0 pt-4 text-right">
                            <Button type="submit" size="large" className="btn-orange-gradiant question-next pr-5 pl-5" variant="contained">Next</Button>
                        </Col>
                    </div>
                </form>
            </div>
        );
    }
}
const CREATE_QUESTIONS = gql`
mutation(
    $bio_id : bioMethodInputs
    $Inputs : [questionEdit!]
) {
    questionArray (
        Inputs : {
            bio    : $bio_id
            Inputs : $Inputs
        }
    ) {
        Status {
            code
            title
            message
            check
        }
        results {
            code
            title
            message
            check
        }
        bio{
            title
            questions{
                id
                title
              }
        }
    }
}
`
const DELETE_QUESTION = gql`
mutation($question_id :  Int ! ){
    questionDelete(Inputs:{
      id: $question_id
    }){
      Status{
        code
      }
    }
  }
  
`

export default compose(
    graphql(CREATE_QUESTIONS, {
        name: "createQuestions"
    }),
    graphql(DELETE_QUESTION, {
        name: "delete_question"
    })
)(withRouter(Questions));